module.exports = __webpack_public_path__ + "img/container-5-v.742eee19.png";